module.exports = ".row{\r\n    padding:20px 0px 10px;\r\n    }\r\n    \r\n    .row:nth-child(odd){\r\n        background: #f3f3f3;\r\n    }\r\n    \r\n    .custom-label{\r\n        font-weight: bold;\r\n        }\r\n    \r\n    .mandatory{\r\n            color:red;\r\n        }"


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/project/project-form/project-form.component.css
// module id = ./src/app/masters/project/project-form/project-form.component.css
// module chunks = main